/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  MetaJungleInterface,
  MetaJungleInterfaceInterface,
} from "../MetaJungleInterface";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bushId",
        type: "uint8",
      },
    ],
    name: "camp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "close",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "gank",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "namehash",
        type: "bytes32",
      },
      {
        internalType: "int8",
        name: "leverage",
        type: "int8",
      },
    ],
    name: "open",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "slotId",
        type: "uint8",
      },
    ],
    name: "propose",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "startVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "summon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8[]",
        name: "bushIdList",
        type: "uint8[]",
      },
    ],
    name: "vote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class MetaJungleInterface__factory {
  static readonly abi = _abi;
  static createInterface(): MetaJungleInterfaceInterface {
    return new utils.Interface(_abi) as MetaJungleInterfaceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaJungleInterface {
    return new Contract(address, _abi, signerOrProvider) as MetaJungleInterface;
  }
}
